import { useEffect, useRef, useState } from "react";
import React from "react";
const SearchableDropdown = ({
    options,
    label,
    id,
    selectedVal,
    handleChange,
    connectionType
}) => {
    const [query, setQuery] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        document.addEventListener("click", toggle);
        return () => document.removeEventListener("click", toggle);
    }, []);

    const selectOption = (option) => {
        setQuery(() => "");
      
        console.log(connectionType + "connectionType");
        const selectedValue = (connectionType == 'SQLite') ? option[label] : option.value;
        handleChange(selectedValue);
        setIsOpen((isOpen) => !isOpen);
    };

    function toggle(e) {

        setIsOpen(e && e.target === inputRef.current);
    }

    // const getDisplayValue = () => {
    //     if (query) return query;
    //     if (selectedVal) return selectedVal;

    //     return "";
    // };
    const getDisplayValue = () => {
        if (query) return query;
        console.log(JSON.stringify(selectedVal) + "selectedVal");
        if (typeof selectedVal === 'string') {
            return selectedVal; // Display the selectedVal string
        } else if (selectedVal && typeof selectedVal === 'object') {
            return selectedVal.label; // Display the 'label' property of the object
        }
        return "";
    };

    const filter = (options) => {
        if (!Array.isArray(options)) {
            return [];
        }
        return options.filter((option) => {
            if (connectionType === "SQLite" && option[label]) {
                // For SQLite, use option[label] for filtering
                return option[label].toLowerCase().includes(query.toLowerCase());
            } else if (option.value && typeof option.value === "string") {
                // For other cases, use option.value if it's a string
                return option.value.toLowerCase().includes(query.toLowerCase());
            } else {
                return false; // Filter out non-string or undefined values
            }
        });

    };

    return (
        <div className="search-dropdown">
            <div className="control">
                <div className="selected-value">
                    <input
                        ref={inputRef}
                        type="text"
                        placeholder="Enter a value"
                        value={getDisplayValue()}
                        name="searchTerm"
                        onChange={(e) => {
                            setQuery(e.target.value);
                            handleChange(e.target.value);
                        }}
                        onClick={toggle}
                    />
                </div>
                <div className={`arrow ${isOpen ? "open" : ""}`}></div>
            </div>

            <div className={`options ${isOpen ? "open" : ""}`}>
                {filter(options).map((option, index) => {
                    return (
                        <div
                            onClick={() => selectOption(option)}
                            className={`option ${option[label] === selectedVal ? "selected" : ""
                                }`}
                            key={`${id}-${index}`}
                        >
                            {option[label]}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SearchableDropdown;
